import type { GetConsumerPointsHistoryResponse } from "@jti/evo-client";
import type { CustomerReferralHistoryResponseType } from "@jti/rest-api-types";

export const convertReferralHistoryEvoResponse = (
  response: GetConsumerPointsHistoryResponse
): CustomerReferralHistoryResponseType => {
  return {
    items: response.data.map((item) => ({
      points: item.points,
      date: item.created_at,
      event: item.type,
    })),
    total: response.meta.total ?? 0,
  };
};
